export default __webpack_public_path__ + "static/media/ViviClinic_logo.4a0826fd.jpg";